import { Reveal, MaskedLines } from "./motion";

export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative h-[60vh] min-h-[420px] overflow-hidden bg-emerald-dark flex items-end" data-testid="page-hero">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-emerald-dark/90 via-emerald-dark/40 to-black/30" />
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-5 lg:px-10 pb-16">
        <p className="eyebrow text-gold-light mb-4">{eyebrow}</p>
        <h1 className="font-serif text-cream font-light text-5xl lg:text-7xl leading-[0.95] tracking-tight">
          <MaskedLines lines={Array.isArray(title) ? title : [title]} />
        </h1>
        {subtitle && <Reveal delay={0.5}><p className="text-cream/70 mt-6 max-w-xl leading-relaxed">{subtitle}</p></Reveal>}
      </div>
    </section>
  );
}
